/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { qreq } from "../../shared/qrequest";
import BaseCom from "../BaseCom";

export default class PaymentCom extends BaseCom {
    getAvailable = async (sid) => {
        try {
            let j = await qreq.getAsync('/api/payment/available');
            if (j.item) {
                this.setState({ methods: j.item });
                return j.item;
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }



    loadSession = async (sid) => {
        this.setState({ sessionID: sid });
        try {
            let j = await qreq.getAsync('/api/session/get/' + sid);
            if (j.errorCode === 0) {
                this.setState({ session: j.item });
                await this.loadMerchant(j.item);
                return j.item;
            }
            else
                this.setState({ error: j.errorMessage });
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }


    loadMerchant = async (session) => {
        try {
            let j = await qreq.postAsync('/api/merchant/details', session);
            this.setState({ merchant: j.item });
            return j.item;
        }
        catch (e) {
            console.error(e);
        }
    }
}